import React from "react";
import moment from "moment";
import Pagination from "../../../../../components/common/Pagination";
import { TableCheckout } from "../../../../../api/user/restaurants";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../../../hooks/useTranslation";

function Booking({
  isLoading,
  isError,
  error,
  reservations = [],
  pagination,
  setPage,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    const [hourStr, minute] = timeStr.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };

  const updateMutation = useMutation({
    mutationFn: TableCheckout,
    onSuccess: ({ url }) => {
      if (url) {
        window.open(url, "_blank");
      } else {
        toast.error(t("tablebooking").checkoutUrlNotFound);
      }
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        t("tablebooking").failedToGetCheckoutUrl;
      toast.error(errorMessage);
    },
  });

  const payTokenMoney = (reservationId) => {
    updateMutation.mutate({ reservationId });
  };

  return (
    <div className="overflow-x-auto md:mt-[30px] mt-[30px]">
      <table className="min-w-full">
        <thead className="bg-[#FFFAF2]">
          <tr>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").bookingId}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").bookingDate}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").time}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").mealType}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").guests}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").foodType}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").tokenCharges}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").discount}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").tableNo}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").tableCode}
            </th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">
              {t("tablebooking").status}
            </th>
            {/* <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">{t("tablebooking").status}</th>      
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Booking Date</th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Time</th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Meal Type</th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Guests</th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Food Type</th>

            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Token Charges</th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Discount</th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Table No</th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Table Code</th>
            <th className="text-left text-lg font-medium text-[#000000] py-[12px] px-[16px]">Status</th> */}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="7" className="text-center py-8">
                <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
              </td>
            </tr>
          ) : isError ? (
            <tr>
              <td colSpan="7" className="text-center py-8 text-red-500">
                {error?.message || t("tablebooking").somethingWentWrong}
              </td>
            </tr>
          ) : reservations?.length === 0 ? (
            <tr>
              <td
                colSpan={reservations?.length === 0 ? "11" : "7"}
                className="text-center py-8 text-gray-500"
              >
                {t("tablebooking").noReservations}
              </td>
            </tr>
          ) : (
            reservations.map((reservation) => (
              <tr key={reservation._id} className="border-t border-[#E4E4E4]">
                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {reservation.reservationId}
                </td>
                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {moment(reservation.bookingDate).format("DD MMM YYYY")}
                </td>
                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {formatTime(reservation?.slot?.startTime)} -{" "}
                  {formatTime(reservation?.slot?.endTime)}
                </td>

                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {reservation.mealType}
                </td>
                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {reservation.totalGuest}
                </td>
                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black capitalize">
                  {reservation.foodType}
                </td>

                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  ₾{reservation.tokenCharges}
                </td>
                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {reservation.discountPercentage}%
                </td>
                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {reservation.tableNo || "-"}
                </td>
                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {reservation.tableCode || "-"}
                </td>

                <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                  {(() => {
                    const status = reservation?.status?.toLowerCase();
                    // const bookingDate = moment(reservation.bookingDate).format("YYYY-MM-DD");
                    // const endTime = reservation?.slot?.endTime;

                    // let isExpired = false;

                    // if (bookingDate && endTime) {
                    //   const [endHour, endMinute] = endTime.split(":");
                    //   const endDateTime = moment(bookingDate)
                    //     .set({ hour: +endHour, minute: +endMinute, second: 0, millisecond: 0 });

                    //   isExpired = moment().isAfter(endDateTime);
                    // }

                    const bookingDate = moment(reservation.bookingDate).format(
                      "YYYY-MM-DD"
                    );
                    const endTime = reservation?.slot?.endTime;

                    let isExpired = false;

                    if (bookingDate && endTime) {
                      const [endHour, endMinute] = endTime.split(":");
                      const endDateTime = moment(bookingDate).set({
                        hour: +endHour,
                        minute: +endMinute,
                        second: 0,
                        millisecond: 0,
                      });

                      isExpired = moment().isAfter(endDateTime);
                    }

                    const isToday = moment().isSame(bookingDate, "day");

                    // If booking date is in past, always expired
                    // if (isExpired) {
                    //   return (
                    //     <button className="bg-gray-500 text-white px-5 py-2 rounded-full text-sm">
                    //       Expired
                    //     </button>
                    //   );
                    // }

                    if (
                      (status === "pending" ||
                        status === "awaiting payment" ||
                        status === "confirmed") &&
                      isExpired
                    ) {
                      return (
                        <button className="bg-gray-500 text-white px-5 py-2 rounded-full text-sm">
                          {t("tablebooking").expired}
                        </button>
                      );
                    }

                    if (status === "pending") {
                      return (
                        <button className="bg-yellow-500 text-white px-5 py-2 rounded-full text-sm">
                          {t("tablebooking").pending}
                        </button>
                      );
                    } else if (status === "awaiting payment") {
                      return (
                        <button
                          onClick={() => payTokenMoney(reservation?._id)}
                          className="bg-green-500 text-white px-5 py-2 rounded-full text-sm"
                        >
                          {t("tablebooking").pay}
                        </button>
                      );
                    } else if (status === "placed") {
                      return (
                        <button
                          onClick={() => payTokenMoney(reservation?._id)}
                          className="bg-slate-400 text-white px-5 py-2 rounded-full text-sm"
                        >
                          {t("tablebooking").orderPlaced}
                        </button>
                      );
                    } else if (status === "confirmed") {
                      if (isToday) {
                        return (
                          <button
                            onClick={() =>
                              navigate("/tableconfirmation", {
                                state: { reservation },
                              })
                            }
                            className="bg-green-600 text-white px-5 py-2 rounded-full text-sm"
                          >
                            {t("tablebooking").placeOrder}
                          </button>
                        );
                      } else {
                        return (
                          <button
                            onClick={() =>
                              navigate("/tableconfirmation", {
                                state: { reservation },
                              })
                            }
                            // onClick={()=> toast.error("Orders can only be placed on the day of your reservation.")}
                            className="bg-green-600 text-white px-5 py-2 rounded-full text-sm"
                          >
                            {t("tablebooking").confirmed}
                          </button>
                        );
                      }
                    } else if (status === "cancelled") {
                      return (
                        <button className="bg-red-500 text-white px-5 py-2 rounded-full text-sm">
                          {t("tablebooking").cancelled}
                        </button>
                      );
                    } else {
                      return (
                        <button className="bg-gray-300 text-black px-5 py-2 rounded-full text-sm">
                          {reservation?.status}
                        </button>
                      );
                    }
                  })()}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {pagination?.totalPages > 1 && (
        <Pagination
          page={pagination.page}
          totalPages={pagination.totalPages}
          setPage={setPage}
        />
      )}
    </div>
  );
}

export default Booking;
